import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "countryselection",
  inputs: [
    {
      name: "country",
      label: "Which Country do you want to go in?",
      placeholder: "Canada",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "province",
      label: "Province",
      placeholder: "Ontario",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "city",
      label: "City",
      placeholder: "Brampton",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "cost_of_living",
      label: "Cost of living",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 400,
      assistance: true,
      inputDependencies: ["city", "country"],
      helpType: "cost_of_living",
      required: true,
    },
  ],
};

export default formFields;
